module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "question-options list-group"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "list-group-item border-0",
      class: {
        active: _vm.selection.indexOf(item) > -1
      },
      domProps: {
        "innerHTML": _vm._s(item.key + '. ' + item.text)
      },
      on: {
        "click": function($event) {
          _vm.select(item)
        }
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53811676!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/Options.vue
// module id = 728
// module chunks = 1